import { useContext } from 'react'

import { BadgesContext } from '../providers/BadgesProvider'

export const useBadgesContext = () => {
  const badgesContext = useContext(BadgesContext)

  if (badgesContext === undefined) {
    throw new Error('badgesContext must be used within a BadgesProvider')
  }

  return badgesContext
}
